// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Password Reset Page Styles */
.reset-password-container {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.reset-password-container input:focus,
.reset-password-container select:focus {
  outline-offset: 2px;
  outline: 2px solid #9ca3af;
  border-color: #9ca3af !important;
  box-shadow: 0 0 0 2px rgba(156, 163, 175, 0.2) !important;
}

.reset-password-container input:hover:not(:focus) {
  background-color: #fafafa;
  transition: all 0.2s ease-in-out;
  border-color: #9ca3af !important;
}

.reset-password-container button[type="button"]:hover:not(:disabled) {
  transform: translateY(-1px);
  background-color: #1d4ed8 !important;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25) !important;
}

.reset-password-container .form-card {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.reset-password-container label {
  color: #111827;
  letter-spacing: -0.025em;
  font-family: 'Roboto', sans-serif;
  font-weight: 500 !important;
}

.reset-password-container .validation-error {
  color: #dc2626;
  margin-top: 0.5rem;
  font-size: 0.875rem;
  font-weight: 400;
}

@media (max-width: 1023px) {
  .reset-password-container button,
  .reset-password-container input {
    touch-action: manipulation;
    min-height: 44px;
  }
}

@media (pointer: coarse) {
  .reset-password-container button:hover {
    transform: none;
  }

  .reset-password-container button:active {
    transition: transform 0.1s;
    transform: translateY(1px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RestPassword.css"],"names":[],"mappings":"AAEA,+BAA+B;AAC/B;EACE,gFAAgF;AAClF;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap\");\n\n/* Password Reset Page Styles */\n.reset-password-container {\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.reset-password-container input:focus,\n.reset-password-container select:focus {\n  outline-offset: 2px;\n  outline: 2px solid #9ca3af;\n  border-color: #9ca3af !important;\n  box-shadow: 0 0 0 2px rgba(156, 163, 175, 0.2) !important;\n}\n\n.reset-password-container input:hover:not(:focus) {\n  background-color: #fafafa;\n  transition: all 0.2s ease-in-out;\n  border-color: #9ca3af !important;\n}\n\n.reset-password-container button[type=\"button\"]:hover:not(:disabled) {\n  transform: translateY(-1px);\n  background-color: #1d4ed8 !important;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25) !important;\n}\n\n.reset-password-container .form-card {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.reset-password-container label {\n  color: #111827;\n  letter-spacing: -0.025em;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500 !important;\n}\n\n.reset-password-container .validation-error {\n  color: #dc2626;\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n@media (max-width: 1023px) {\n  .reset-password-container button,\n  .reset-password-container input {\n    touch-action: manipulation;\n    min-height: 44px;\n  }\n}\n\n@media (pointer: coarse) {\n  .reset-password-container button:hover {\n    transform: none;\n  }\n\n  .reset-password-container button:active {\n    transition: transform 0.1s;\n    transform: translateY(1px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
